import { videoStatusTypes } from 'helpers/interactiveVideoStatus'

export function isVideoUploading(interactiveVideo) {
	return interactiveVideo.media.asset.status === videoStatusTypes.UPLOADING
    && interactiveVideo.media.asset.progress !== 100
}
